import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SaveDataGuard } from 'src/app/common/guards/save-data-guard/save-data.guard';

import { PagesTitle } from 'src/app/app-pages-title/app-pages-title';
import { editEntityResolver, RouteService, viewEntityResolver } from 'src/app/services/route-service.abstract';
import { Post } from 'src/app/swagger-api';
import { createProvider } from 'src/app/utils';
import { CreatePostComponent } from './create-post/create-post.component';
import { PostDetailComponent } from './post-detail-info/post-detail.component';
import { PostRoutesService } from './post-route.service';
import { PostsNavigationComponent } from './posts-navigation.component';
import { UpdatePostComponent } from './update-post/update-post.component';
import { UserPostsComponent } from './user-posts/user-posts.component';

export const postsRoutes: Routes = [
  {
    path: '',
    component: PostsNavigationComponent,
    providers: [createProvider(RouteService, { useClass: PostRoutesService })],
    children: [
      { path: '', redirectTo: 'all', pathMatch: 'full' },
      { path: 'all', component: UserPostsComponent, title: PagesTitle.POSTS_LIST_PAGE },
      {
        path: 'create',
        component: CreatePostComponent,
        title: PagesTitle.CREATE_POST_PAGE,
        pathMatch: 'full',
        canDeactivate: [SaveDataGuard],
      },
      {
        path: 'view/:id',
        component: PostDetailComponent,
        resolve: { post: viewEntityResolver<Post>() },
        canDeactivate: [SaveDataGuard],
      },
      {
        path: 'update/:id',
        component: UpdatePostComponent,
        resolve: { post: editEntityResolver<Post>() },
        canDeactivate: [SaveDataGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(postsRoutes)],
  exports: [RouterModule],
})
export class PostsRoutingModule {}
